import { GetStaticProps, GetStaticPaths, GetServerSideProps } from "next";
import React, { useContext, useEffect, useState } from "react";
import useEffectOnce from "../../hooks/use-effect-once";
import { Box, Typography, Button, CardContent, Card, Avatar, Stack, Rating, useMediaQuery, Divider, } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import Link from "next/link";
import parse from "html-react-parser";
import ReactHtmlParser from 'react-html-parser';
import Products from "@/components/cards/product-bestsell-small";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faMessage, faStore } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import { GetStoreActive } from "@/api/store";
import { useRouter } from "next/router";
import Cookies from "universal-cookie";
import { joinRoom, openChatDialog } from "@/store/slices/chatSlice";
import { useDispatch } from "react-redux";
import { saveRedirectPath } from "@/utils/sessionRedirect";
import { checkLoginStatus } from "@/utils/authen";


export default function StoreProfile({ data_info, product_type }: any) {

  const isMobile = useMediaQuery('(max-width:600px)');
  const { isLoggedIn } = checkLoginStatus();
  const dispatch = useDispatch();
  const [getFormatDate, setGetFormatDate] = useState<string>("");
  const [durationMessage, setDurationMessage] = useState<string>("");
  const [active, setActive] = useState("");
  const router = useRouter();
  const cookies = new Cookies();
  const authToken = cookies.get("token");
  const getToken = authToken !== "" ? authToken : null;
  const storeId = router.query.store;
  const productId = router.query.id;
  const moment = require('moment');

  if (data_info == null) {
    return "";
  }
  if (typeof data_info === "object" && data_info !== null && "message" in data_info) {
    return data_info.message;
  }

  const fnConvertTime = () => {
    const storeUpdateAt = data_info?.store?.store_open_at;
    if (storeUpdateAt === null) {
      setDurationMessage(`ไม่มีการอัพเดท`);
    } else {

      const date = new Date(storeUpdateAt) as any;
      const buddhistYear = date.getFullYear() + 543;

      const thaiMonthNames = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];
      const thaiMonth = thaiMonthNames[date.getMonth()];

      const formattedDate = `${date.getDate()} ${thaiMonth} ${buddhistYear}`;
      setGetFormatDate(formattedDate);

      // Count duration in hours
      const currentTime = new Date() as any;
      const duration = Math.abs(currentTime - date) / 36e5; // Convert milliseconds to hours

      if (duration >= 24) {
        const formattedDuration = `${date.getDate()} ${thaiMonth} ${buddhistYear}`;
        setDurationMessage(`ตั้งแต่วันที่ ${formattedDuration}`);
      } else {
        setDurationMessage(`น้อยกว่า ${duration.toFixed(0)} ชั่วโมงที่ผ่านมา`);
      }
    }
  }


  const FetchGetStoreActive = async (getToken: string, storeId: any) => {
    const response = await GetStoreActive(getToken, storeId)

    if (response?.success === true) {
      setActive(response?.data)
    }
  }


  useEffect(() => {

    fnConvertTime();
    FetchGetStoreActive(getToken, storeId);

  }, []);
  let now = moment().locale('th').format('MMMM Do YYYY');
  const [storeTitle, setStoreTitle] = useState('');


  useEffect(() => {

    if (data_info.store && data_info.store.store_info_multilanguage && data_info.store.store_info_multilanguage.length > 0) {
      const title = data_info.store.store_info_multilanguage[0].store_title;
      setStoreTitle(title);
    }
  }, [data_info]);

  const handleOpenChat = () => {
    
    saveRedirectPath();

    if (!isLoggedIn) {
        // router.push(`/account/signin`);
        window.location.href = "/account/signin";
        return; 
    }
    else {
      dispatch(openChatDialog({
        openChatDialog: new Date().getTime()
      }))

      setTimeout(() => {
        dispatch(joinRoom({
          participateId: data_info.store.member_id,
          userType: 'seller',
          productId: productId,
          storeId: data_info.store.id
        }))
      }, 1200)
    }
  }

  return (
    <>

      <Card variant="outlined" sx={{ mt: 3 }}>
        <CardContent sx={{ "&:last-child": { pb: 0 } }}>
          {isMobile ? (
            <>
              <Grid container spacing={2}>
                <Grid xs={12} md={12}>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    className="CardProfile"
                    alignItems="center"
                    justifyContent="space-between"
                    marginBottom="10px"
                  >
                    <Box display="inline-flex">
                      <Avatar
                        sx={{ mt: 2 }}
                        className="Avatar-img"
                        alt={data_info?.store?.store_icon_image}
                        src={data_info?.store?.store_icon_image}
                      />


                      <Card sx={{ boxShadow: "unset", minWidth: 245 }}>
                        <CardContent>
                          <Typography gutterBottom variant="h5" component="div"
                            className="fontSize-20 txt-bold"
                          >
                            {(
                              data_info?.store?.store_info_multilanguage as string[]
                            ).map((dataTil) => {
                              if (dataTil.lang == "th") {
                                return ReactHtmlParser(dataTil.store_title);
                              }
                            })}

                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            <span style={{ fontSize: '10px' }}>Active {active}</span>
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 2
                            }}
                          >
                            <Box>
                              <Grid container spacing={5}>
                                <Grid xs={12} md={4} sx={{ padding: "0px", mt: 2, ml: 2 }}>
                                  <Stack direction={"row"}>
                                    {data_info?.store?.store_score > 0 && (
                                      <>
                                        <Rating
                                          size="small"
                                          precision={0.5}
                                          sx={{ fontSize: 14, mb: 1 }}
                                          name="read-only"
                                          value={data_info?.store?.store_score}
                                          readOnly
                                        />
                                        <Box sx={{ mr: 1, ml: 1 }}>
                                          {/* {data_info.store.store_score
                                            ? parseFloat(data_info.store.store_score).toFixed(1)
                                            : "0"} */}
                                          {data_info.store.store_score}

                                        </Box>
                                      </>
                                    )}


                                  </Stack>
                                </Grid>
                                <Grid xs={12} md={8} sx={{ padding: "0px", ml: 2 }}>
                                  {data_info?.store?.product_sum > 0 && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        component="div"
                                        className="gray"
                                      >
                                        รายการบริการ/สินค้า{" "}
                                        <Box component="p" className="txt-bold black" sx={{ display: 'inline' }}> {data_info?.store?.product_sum
                                          ? data_info?.store?.product_sum
                                          : ""}{" "}</Box>
                                      </Typography>
                                      <Divider orientation="vertical" flexItem />
                                    </>
                                  )}

                                  <Typography
                                    className="gray"
                                    component="div"
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    เริ่มขาย  <Box component="p" className="txt-bold black" sx={{ display: 'inline' }}>{getFormatDate}</Box>
                                  </Typography>
                                </Grid>
                              </Grid>

                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>
                    <Box
                      className="Card-btn"
                      sx={{
                        "& a": {
                          mb: 2,
                          // mr: 1,
                          maxWidth: "100%",
                          display: "flex",
                          textAlign: "center",
                          borderRadius: "8px",
                          variant: "outlined",
                          border: "1px solid #DEE2E6 ",
                          height: "100%",
                          backgroundColor: " #ffffff"
                        }
                      }}
                    >
                      <Link
                        className="btn-5"
                        href={'#'}
                        onClick={handleOpenChat}
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   e.stopPropagation();

                      //   dispatch(openChatDialog({
                      //     openChatDialog: new Date().getTime()
                      //   }))

                      //   setTimeout(() => {
                      //     dispatch(joinRoom({
                      //       participateId: data_info.store.member_id,
                      //       userType: 'seller',
                      //       productId: productId,
                      //       storeId: data_info.store.id
                      //     }))
                      //   }, 1200)
                      // }}
                      >
                        <Stack direction="row" sx={{ justifyContent: "center", width: "100%", py: 2, textAlign: "center" }}>
                          <FontAwesomeIcon
                            icon={faCommentDots}
                            style={{ marginRight: "4px", fontSize: "24px", width: "20px", }}
                          />

                          <Typography>พูดคุย</Typography>
                        </Stack>
                      </Link>
                      <Link
                        href={{
                          pathname: `/store/${data_info?.store?.store_slug}`,
                          query: { store: data_info?.store?.id, product_type: "Product" }
                        }}
                        style={{ color: "secondary" }}
                      >
                        <Stack direction="row" sx={{ justifyContent: "center", width: "100%", py: 2, textAlign: "center" }}>
                          <FontAwesomeIcon
                            icon={faStore}
                            style={{ marginRight: "4px", fontSize: "24px", width: "20px" }}
                          />
                          <Typography>ดูร้านค้า</Typography>
                        </Stack>
                      </Link>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </>

          ) : (
            <Grid container spacing={2}>
              <Grid xs={12} md={12}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 1, sm: 2, md: 4 }}
                  className="CardProfile"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="inline-flex">
                    <Avatar

                      className="Avatar-img"
                      alt={data_info?.store?.store_icon_image}
                      src={data_info?.store?.store_icon_image}
                    />


                    <Card sx={{ boxShadow: "unset", minWidth: 245 }}>
                      <CardContent>
                        <Typography gutterBottom variant="h5" className="fontSize-20 txt-bold" component="div">

                          {Array.isArray(data_info?.store?.store_info_multilanguage) && (
                            data_info.store.store_info_multilanguage.map((dataTil: any) => {
                              if (dataTil.lang === "th") {
                                return ReactHtmlParser(dataTil.store_title);
                              }
                              return null;
                            })
                          )}


                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <span style={{ fontSize: '10px' }}>Active {active}</span>
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mt: 2
                          }}
                        >
                          <Box>
                            {data_info?.store?.store_score > 0 && (
                              <Stack direction={"row"}>
                                <Rating
                                  size="small"
                                  precision={0.5}
                                  sx={{ fontSize: 14, mt: 0.5 }}
                                  name="read-only"
                                  value={data_info?.store?.store_score}
                                  readOnly
                                />
                                <Box sx={{ mr: 1, ml: 1 }}>
                                  {/* {data_info.store.store_score
                                    ? parseFloat(data_info.store.store_score).toFixed(1)
                                    : "0"} */}
                                    {data_info.store.store_score}

                                </Box>

                              </Stack>
                            )}

                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                alignItems: "center",
                                gap: '10px'
                              }}
                            >
                              {data_info?.store?.product_sum > 0 && (
                                <>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      component="div"
                                      className="gray"
                                    >
                                      รายการสินค้า{" "}
                                      <Box component="p" className="txt-bold black" sx={{ display: 'inline' }}> {data_info?.store?.product_sum
                                        ? data_info?.store?.product_sum
                                        : ""}{" "}</Box>
                                    </Typography>
                                    <Divider orientation="vertical" flexItem />
                                </>
                              )}

                              <Typography
                                className="gray"
                                component="div"
                                variant="body2"
                                color="text.secondary"
                              >
                                เริ่มขาย  <Box component="p" className="txt-bold black" sx={{ display: 'inline' }}>
                                  {getFormatDate}</Box>
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>

                  <Box
                    className="Card-btn"
                    sx={{
                      "& a": {
                        mb: 1,
                        mr: 1,
                        maxWidth: "100%",
                        display: "block",
                        textAlign: "center",
                        borderRadius: "8px",
                        variant: "outlined",
                        border: "1px solid #DEE2E6 ",
                        height: "100%",
                        backgroundColor: " #ffffff"
                      }
                    }}
                  >


                    <Link
                      className="btn-5"
                      href={'#'}
                      onClick={handleOpenChat}
                    >
                      <Stack direction="row" sx={{ justifyContent: "center", width: "100%", py: 2, textAlign: "center" }}>
                        <FontAwesomeIcon
                          icon={faCommentDots}
                          style={{ marginRight: "4px", fontSize: "24px", width: "20px", }}
                        />

                        <Typography>พูดคุย</Typography>
                      </Stack>
                    </Link>
                    <Link
                      className="store"
                      href={{
                        pathname: `/store/${data_info?.store?.store_slug}`,
                        query: { store: data_info?.store?.id, product_type: "Product" }
                      }}
                    >
                      <Stack direction="row" sx={{ justifyContent: "center", width: "100%", py: 2, textAlign: "center" }}>
                        <FontAwesomeIcon
                          icon={faStore}
                          style={{ marginRight: "4px", fontSize: "24px", width: "20px" }}
                        />
                        <Typography>ดูร้านค้า</Typography>
                      </Stack>
                    </Link>
                  </Box>
                </Stack>
              </Grid>
            </Grid >
          )}


          <Products dataSet={null}></Products>
        </CardContent>
      </Card>
    </>
  );
}
